import { GA_TEST_MODE, GA_ID } from 'config';

import ReactGA from 'react-ga';

ReactGA.initialize(GA_ID, { testMode: GA_TEST_MODE });

export const { ga, set, pageview } = ReactGA;
